import { useContext, useEffect } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import { ThemeProvider } from "@mui/material/styles";
import { Alert, Snackbar, Slide } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import StylesProvider from "@mui/styles/StylesProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";

import "./css/style.css";
import createTheme from "./theme";
import Router from "./router/Router";
import useIsMobile from "./hooks/useDeviceInfo";
import useAuthToken from "./hooks/useAuthToken";
import useAuthRedirect from "./hooks/useAuthRedirect";
import { closeAlert } from "./redux/slices/alertSlice";
import { ThemeContext } from "./components/ThemeProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { useBuildVersionCheck } from "./hooks/useBuildVersionCheck";
import useVisitorVerification from "./hooks/useVisitorVerification";
import PushNotification from "./pages/Push Notification/PushNotification";
import { setAccessToken, setDisplayName } from "./redux/slices/memberSlice";
import NewUserDetails from "./pages/New User Details Component/NewUserDetails";
import useServiceWorkerRegistration from "./hooks/useServiceWorkerRegistration";
import URLVerification from "./pages/URLVerification/URLVerification";
import InternetChecker from "./utils/InternetChecker";
import useBusinessTheme from "./hooks/useBusinessTheme";

function App() {
  const { theme } = useContext(ThemeContext);

  const dispatch = useDispatch();
  const location = useLocation();
  const alert = useSelector((state) => state.alertDetails);

  useAuthToken();

  // useBusineswqwqwqsTheme();

  PushNotification();

  useBuildVersionCheck();

  //q useVisitorVerification();

  useServiceWorkerRegistration();

  useEffect(() => {
    dispatch(setAccessToken(sessionStorage.getItem("authToken")));
    dispatch(setDisplayName(sessionStorage.getItem("displayName")));
  }, []);

  useEffect(() => {
    sessionStorage.getItem("previousPage") != "/login" &&
      location.pathname + location.search != "/login" &&
      sessionStorage.setItem(
        "previousPage",
        location.pathname + location.search ||
          sessionStorage.getItem("previousPage")
      );

    if (location.pathname !== "/error-500") {
      sessionStorage.setItem("lastPath", location.pathname);
    }
  }, []);

  return (
    <HelmetProvider>
      <Helmet titleTemplate="%s | Verismart.ai" defaultTitle="Verismart AI" />

      <StylesProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <MuiThemeProvider theme={createTheme(theme)}>
            <ThemeProvider theme={createTheme(theme)}>
              <Snackbar
                open={alert.state}
                autoHideDuration={4000}
                onClose={handleAlertClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                TransitionComponent={(props) => (
                  <Slide
                    {...props}
                    in={alert.state}
                    direction="right"
                    unmountOnExit
                  />
                )}
                style={{
                  top: "50px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <Alert
                  variant="outlined"
                  severity={alert.type}
                  onClose={handleAlertClose}
                  sx={{
                    minWidth: "350px",
                    background: "white",
                    borderRadius: "10px",
                    marginTop: "10px",
                  }}
                >
                  {alert.message}
                </Alert>
              </Snackbar>
              <InternetChecker />
              <NewUserDetails />
              <Router />
              <URLVerification />
            </ThemeProvider>
          </MuiThemeProvider>
        </LocalizationProvider>
      </StylesProvider>
    </HelmetProvider>
  );

  function handleAlertClose(_, reason) {
    if (reason === "clickaway") {
      return;
    }

    dispatch(closeAlert());
  }
}

export default App;
